const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SETAUDITORIA':
      state = action.auditoria;
      return state;
    case 'AUDITORIA_DEFAULT':
      state = INITIAL_STATE;
      return state;
    default:
      return state;
  }
};